import React from 'react';
import PropTypes from 'prop-types';
import UploadForm from './ui/UploadForm/UploadForm';

const DataUploadForm = ({
  onClose,
  modalService,
  uiNotificationService,
}) => {

  return (
    <UploadForm
      onClose={onClose}
      modalService={modalService}
      uiNotificationService={uiNotificationService}
      //uploadStudy={uploadStudy}
    />
  );
};

DataUploadForm.propTypes = {
  onClose: PropTypes.func
};

export default DataUploadForm;
